import { gql } from '@apollo/client';

export const GET_CASES = gql`
    query lp_read($options: read_options, $region: Region!, $type: DeLp_Type!) {
        lp_read(options: $options, region: $region, type: $type) {
            message
            ok
            status
            total_count
            error {
                message
                path
            }
            data {
                cases {
                    case_id
                    party_1
                    party_1_title
                    party_1_desc
                    party_2
                    party_2_desc
                    party_2_title
                    keywords
                    court_id
                    date_of_judgement
                    facts_and_history
                    issues
                    held
                    case_history
                    case_no
                    casejudgment
                    cases_reference
                    volume
                    wrn_ref
                    filename
                    index
                }
            }
        }
    }
`;

export const LATEST_CASES = gql`
    query latest_cases($days: Int) {
        latest_cases(days: $days)
    }
`;

export const CREATE_LAW_REPORT = gql`
    mutation law_report($data: LawReport!, $region: Region!) {
        law_report(data: $data, region: $region) {
            error {
                message
                path
            }

            message
            ok
            status
        }
    }
`;

export const MODIFY_LAW_REPORT = gql`
    mutation lp_create_modify(
        $data: [lp_create_modify_data!]!
        $region: Region!
        $type: DeLp_Type!
    ) {
        lp_create_modify(data: $data, region: $region, type: $type) {
            error {
                message
                path
            }
            message
            ok
            status
        }
    }
`;

export const GET_COURT_CATEGORIES = gql`
    query($options: read_options, $region: Region!, $type: DeLp_Type!) {
        lp_read(options: $options, region: $region, type: $type) {
            data {
                court_categories {
                    court_id
                    court_category
                }
            }
        }
    }
`;
